export default __webpack_public_path__ + "static/media/019-Nick Fury.13911a44.svg";